<template>
  <div>
    <el-card shadow="always">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
          <el-page-header
            title="Home"
            @back="$router.push({ name: 'home'})"
            :content="$t('consultar-terceiros')"
          ></el-page-header>
        </el-col>
        <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4" class="right">
          <el-button icon="el-icon-plus" type="primary" @click="$router.push({ name: 'plp.external.add'})">Registrar PLP</el-button>
        </el-col>
      </el-row>
    </el-card>
    <br />
    <el-card>
      <el-form :model="ruleForm" :inline="true" ref="ruleForm">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="20" :md="20" :lg="20" :xl="20">
            <el-form-item :label="$t('periodo')" prop="name">
              <el-date-picker
                v-model="ruleForm.range"
                type="daterange"
                align="right"
                unlink-panels
                clearable
                range-separator="à"
                format="dd/MM/yyyy"
                start-placeholder="Inicio"
                end-placeholder="Fim"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              :label="$t('cliente')"
              prop="name"
              v-if="userType !== '2' && userType !== '5'"
            >
              <CustomerList
                v-model="ruleForm.customer"
                v-bind:multiple="true"
              />
            </el-form-item>
            <el-form-item :label="$t('servico')" prop="name">
              <ServicesList v-model="ruleForm.service" :multiple="true" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4" class="right">
            <el-button size="mini" type="info" @click="fetchRecords()">Filtrar</el-button>&nbsp;
            <ExternalMoreFilters ref="moreFilterDialog" v-on:filter="fetchRecords" :userType="userType" />
          </el-col>
        </el-row>
      </el-form>
      <br />
      <el-row>
        <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3" v-for="(record, index) in tableData" :key="record.id" :offset="index > 0 ? 1 : 0">
          <el-card class="fixed">
            <img v-if="record.content" :src="record.content" :title="record.name" class="image">
            <span v-else>{{ record.name }}</span>
            <div style="padding: 14px;">
              <span>Postagens: {{ record.total }}</span>
              <div class="bottom clearfix">
                <time class="time">{{ record.value | currency("R$ ", 2, {
                    thousandsSeparator: ".",
                    decimalSeparator: ",",
                  }) }}</time>            
                <el-button type="text" @click="fetchTags(record.id)" class="button">Consultar</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <br />
      <el-row :gutter="5" justify="end">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-dropdown>
            <el-button>
              Exportar
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span @click="doexport('csv')">CSV</span></el-dropdown-item>
              <el-dropdown-item><span @click="doexport('xls')">XLS</span></el-dropdown-item>
              <el-dropdown-item><span @click="doexport('html')">HTML</span></el-dropdown-item>
              <el-dropdown-item><span @click="doexport('xml')">XML</span></el-dropdown-item>
              <!--PrepostPDF :records="tableData" />
              <PrepostXml :records="tableData" />
              <PrepostHtml :records="tableData" /-->
            </el-dropdown-menu>
          </el-dropdown>
          <el-pagination
            class="right"
            :page-size="records"
            background
            v-if="tableTags.length > 0" 
            @current-change="fetchTags()"
            @size-change="changeSize"
            :current-page.sync="page"
            layout="sizes, prev, pager, next"
            :page-sizes="[
              50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
            ]"
            :total="total"
          ></el-pagination>
        </el-col>
      </el-row>
      <ExternalPostTagTable :tableData="tableTags" v-if="tableTags.length > 0" />
    </el-card>
  </div>
</template>
<script>
import { ExternalService } from "@/services/customers/external.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";
import moment from "moment";
import "moment/locale/pt-br";
import ExternalMoreFilters from "./ExternalMoreFilters.vue";
import ExternalPostTagTable from './ExternalPostTagTable.vue';
export default {
  components: { ExternalPostTagTable, CustomerList, ServicesList, ExternalMoreFilters },
  props: ["userType"],
  data() {
    return {
      tableData: [],
      tableTags: [],
      records: 50,
      page: 1,
      total: 0,
      id: null,
      ruleForm: {
        range: [new Date().setDate(new Date().getDate() - 30), new Date()],
        customer: [],
        service: "",
      },
    }
  },
  methods: {
    doexport(type) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      const filter = vm.$refs.moreFilterDialog.get();
      filter.fileType = type;
      ExternalService.export(
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.ruleForm.service,
        filter,
      ).then((response) => {
        this.$message({
          type: "warning",
          message: 'Seu relatório de postagens está sendo gerado, assim que terminar você receberá uma notificação no canto superior direito!',
          duration: 5000,
        });
        vm.$bus.$emit("notifications", response);
      }).catch(() => {
        this.$message({ type: "error", message: error });
      })
      .finally(() => loading.close());
    },
    changeSize(size) {
      const vm = this;
      vm.records = size;
      vm.fetchTags();
    },
    fetchTags(id) {
      const vm = this;
      if (!id) id = vm.id;
      vm.id = id;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      const filter = vm.$refs.moreFilterDialog.get();
      ExternalService.tags(
        id,
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.ruleForm.service,
        filter,
        vm.records,
        vm.page,
      )
        .then((response) => {
          vm.tableTags = response.records;
          vm.total = response.total;
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      const filter = vm.$refs.moreFilterDialog.get();
      ExternalService.resume(
        vm.ruleForm.customer,
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.ruleForm.service,
        filter,
      ).then((response) => {
          vm.tableData = response;
          vm.tableTags = [];
          if (vm.tableData.length == 0) {
            this.$message({
              type: "error",
              message: 'Sem postagens encontrados para o filtro selecionado',
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    }
  },
  mounted() {
    this.fetchRecords();
  }
}
</script>

<style scoped>
.right {
  text-align: center !important;
}
.fixed {
    width: 240px;
    height: 160px;
}
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    height: 60px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
  </style>